import { render, staticRenderFns } from "./japanSecurityshow.vue?vue&type=template&id=2a979059&scoped=true&"
import script from "./japanSecurityshow.vue?vue&type=script&lang=js&"
export * from "./japanSecurityshow.vue?vue&type=script&lang=js&"
import style0 from "./japanSecurityshow.vue?vue&type=style&index=0&id=2a979059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a979059",
  null
  
)

export default component.exports